import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

let editAutocomplete: google.maps.places.Autocomplete;

const componentEditForm = {
  edit_street_number: 'short_name',
  edit_route: 'long_name',
  edit_locality: 'long_name',
  edit_administrative_area_level_1: 'short_name',
  edit_postal_code: 'short_name',
  edit_country: 'short_name',
};

const typePriorityMapping = {
  street_number: 'street_number',
  route: 'route',
  locality: 'locality',
  sublocality_level_1: 'locality',
  administrative_area_level_1: 'administrative_area_level_1',
  administrative_area_level_2: null,
  country: 'country',
  postal_code: 'postal_code',
  political: null,
};

const getAddressTypeFromComponent = (component) => {
  for (const type of component.types) {
    if (
      typePriorityMapping[type] !== undefined &&
      typePriorityMapping[type] !== null
    ) {
      return typePriorityMapping[type];
    }
  }
  return null;
};

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesAutocompleteService {
  isAddressValid$ = new Subject<boolean>();
  isReset$ = new Subject<boolean>();

  validAddress(address) {
    let isValid = false;
    Object.keys(address).forEach((v) => {
      if (!address[v] && v !== 'address2') {
        isValid = true;
      }
    });
    return isValid;
  }

  initEditAutocomplete(country, input) {
    // Create the autocomplete object, restricting the search predictions to
    // geographical location types.

    if (!country) {
      country = ['us', 'ca'];
    }
    const options = {
      types: ['geocode'],
      componentRestrictions: { country },
    };

    // const input = this.googleAutocompleteEdit.nativeElement;
    editAutocomplete = new google.maps.places.Autocomplete(input, options);

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components.
    editAutocomplete.setFields(['address_component']);

    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    editAutocomplete.addListener('place_changed', this.editFillInAddress);
  }

  editFillInAddress() {
    // Get the place details from the autocomplete object.
    const place = editAutocomplete.getPlace();

    const { address_components } = place;
    if (!address_components) {
      return;
    }

    (document.getElementById('edit-form-search') as HTMLInputElement).hidden =
      true;
    (document.getElementById('edit-form-result') as HTMLInputElement).hidden =
      false;
    (document.getElementById('edit_street_number') as HTMLInputElement).value =
      null;

    setTimeout(() => {
      for (const component in componentEditForm) {
        if (component !== 'edit_street_number') {
          (document.getElementById(component) as HTMLInputElement).value = '';
        }
      }

      // Get each component of the address from the place details,
      // and then fill-in the corresponding field on the form.
      let street_number;

      for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
        const addressType = getAddressTypeFromComponent(component);

        if (addressType && componentEditForm[`edit_${addressType}`]) {
          let val = component[componentEditForm[`edit_${addressType}`]];
          if (addressType === 'street_number') {
            street_number = val || '';
          } else {
            if (addressType === 'route') {
              if (street_number) {
                val = `${street_number} ${val}`;
              }
            }
            (
              document.getElementById(`edit_${addressType}`) as HTMLInputElement
            ).value = val;
          }
        }
      }
    }, 100);
  }
}
